import React from 'react';
import SettingsPage from './SettingsPage';

export default function OfficeSettingsPage() {
  // Office uses the same Projects configuration as CRM.
  return <SettingsPage initialTab={1} forceTab={1} hideTabs hideTitle plain />;
}
